module.exports = __webpack_public_path__ + "static/media/2022-02-27 19.08.55.fad4d026.png";